import type { BranchAgnosticBannerContent, BranchButtonConfig } from './types';

export const ENTRYPOINT_ENTITY_NAME = 'cc_recommend_flow_multibutton';
export const ENTRYPOINT_SECTION_NAME = 'ru_cardfinder_entry';

export const BRANCH_AGNOSTIC_CONTENT: BranchAgnosticBannerContent = {
  eyebrow: 'CardFinder: Free card recommendation quiz',
  headlineLead: 'Not sure which card is right for you?',
  headlineHighlight: "We'll find your match.",
  footnoteMinutes: '1–2 minutes',
  footnoteNoImpact: 'No impact to credit score',
};

/** Ordered as in the Figma mock; array index is sent as `item_position`. */
export const BRANCH_BUTTONS: BranchButtonConfig[] = [
  { label: 'Travel Rewards and Perks', branch: 'travel', analyticsBranch: 'travel' },
  { label: 'Build Credit', branch: 'building-credit', analyticsBranch: 'build_credit' },
  { label: 'Earn Cash Back', branch: 'cash-back', analyticsBranch: 'cash_back' },
  { label: 'Transfer a Balance', branch: 'balance-transfer', analyticsBranch: 'balance_transfer' },
  { label: 'Save on Interest', branch: 'saving-interest', analyticsBranch: 'save_interest' },
];
